// ─────────────────────────────────────────────────────────────
//  ✏️  EDIT THIS FILE FOR EACH NEW HOURS REQUEST
//  Change CONFIG for client/lease/due date.
//  Change ASSETS to match the lease schedule.
// ─────────────────────────────────────────────────────────────

export const CONFIG = {
  client:  'Alcoa, Massena NY',
  lease:   '2397-44',
  dueDate: 'May 13, 2026',
};

// Category options: 'MHE' | 'Charger' | 'Battery' | 'Accessories'
// MHE assets require hours. All others default to N/A.
export const ASSETS = [
  { id: 0,  model: '8FBE20U',    serial: '8FBE20U-30553',  desc: 'Toyota 8FBE20U — Electric 3-Wheel Sit Down Forklift',    category: 'MHE' },
  { id: 1,  model: '8FBE20U',    serial: '8FBE20U-30554',  desc: 'Toyota 8FBE20U — Electric 3-Wheel Sit Down Forklift',    category: 'MHE' },
  { id: 2,  model: '8FBE20U',    serial: '8FBE20U-30555',  desc: 'Toyota 8FBE20U — Electric 3-Wheel Sit Down Forklift',    category: 'MHE' },
  { id: 3,  model: '8FBE20U',    serial: '8FBE20U-30556',  desc: 'Toyota 8FBE20U — Electric 3-Wheel Sit Down Forklift',    category: 'MHE' },
  { id: 4,  model: '8FBE20U',    serial: '8FBE20U-30557',  desc: 'Toyota 8FBE20U — Electric 3-Wheel Sit Down Forklift',    category: 'MHE' },
  { id: 5,  model: '8FBCHU25',   serial: '8FBCHU25-41201', desc: 'Toyota 8FBCHU25 — Electric Counterbalance Forklift',     category: 'MHE' },
  { id: 6,  model: '8FBCHU25',   serial: '8FBCHU25-41202', desc: 'Toyota 8FBCHU25 — Electric Counterbalance Forklift',     category: 'MHE' },
  { id: 7,  model: '8FBCHU25',   serial: '8FBCHU25-41203', desc: 'Toyota 8FBCHU25 — Electric Counterbalance Forklift',     category: 'MHE' },
  { id: 8,  model: 'MPB045VG',   serial: 'MPB045VG-72891', desc: 'Toyota MPB045VG — Electric Walkie Pallet Jack',          category: 'MHE' },
  { id: 9,  model: 'MPB045VG',   serial: 'MPB045VG-72892', desc: 'Toyota MPB045VG — Electric Walkie Pallet Jack',          category: 'MHE' },
  { id: 10, model: 'V2S',        serial: 'N/A',            desc: 'GemOne V2S — Telemetry Accessories',                    category: 'Accessories' },
  { id: 11, model: 'NIP3-JN-4Y', serial: 'RYA00612812',   desc: 'Enersys NIP3-JN-4Y — Conventional Charger',             category: 'Charger' },
  { id: 12, model: '18-E100-21', serial: 'RXF00546125',    desc: 'Exide 18-E100-21 — Conventional Battery',               category: 'Battery' },
];
